import * as Yup from "yup";

const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

export const LoginSchema = Yup.object({
    phone: Yup.string().trim().email("Enter a valid email").matches(EMAIL_RE, "Enter a valid email").required("Enter Your Email"),
    password: Yup.string().required("Enter Your Password").test('blank', "Enter Your Password", (value) => !!value && value.trim().length > 0),
});
